import React from 'react'
import { FcGoogle } from 'react-icons/fc'
import '../../app.css'
import firebase from 'firebase'
function SignUp() {
    const GSignUp = () => {
        let provider = new firebase.auth.GoogleAuthProvider();
        const db = firebase.database()
        firebase.auth()
            .signInWithPopup(provider)
            .then((result) => {
                /** @type {firebase.auth.OAuthCredential} */
                let credential = result.credential
                // This gives you a Google Access Token. You can use it to access the Google API.
                let token = credential.accessToken
                // The signed-in user info.
                let user = result.user
                let id = user.uid
                db.ref().child(`users`).child(user.uid).get().then(s => {
                    if (s.exists()) {
                        alert(`Signed in as: ${user.displayName}`)
                        window.location.href = '/'
                    }
                    else {
                        db.ref(`users/${user.uid}`).set({
                            name: user.displayName,
                            photo: user.photoURL,
                            linkid: id
                        })
                            .then(s => {

                            })
                        db.ref(`${user.uid}`).set({
                            user: user.uid
                        })
                            .then(s => {

                            })
                    }
                })
            }).catch((error) => {
                let errorMessage = error.message;
                alert("Log in failed.", errorMessage)
                console.log(errorMessage, error)
            });
    }
    return (
        <>
            <div className='row d-flex justify-content-center align-items-center'>
                <div className='col-xs-1  ' />
                <div className="mt-4 ml-3 mr-3 col-xs-10 col-md-9 col-xl-7 col-sm-10 sign-up-form" >
                    <div id="sign-up-form-class mt-5 mb-auto" >
                        <form style={{ borderRadius: '10px' }} className="form-signup bg-secondary p-4"   >
                            <h2 className='text-primary'> Sign Up</h2>
                            <div className="social-login d-flex justify-content-center" onClick={GSignUp}>
                                <div id='googleSignIn'>
                                    <div>
                                        <FcGoogle id="GoogleLogo" />
                                        <span className='text-primary '>SignUp using Google</span>
                                    </div>
                                </div>
                            </div>
                            <p className='mb-2 mt-3 text-primary' style={{ "textAlign": "center" }}> OR  </p>
                            <input type="text" className="form-control mt-4 mb bg-secondary" placeholder="User name for link share " required autofocus="" />
                            <small className='text-light '>(if left empty a random id will be generated)</small>
                            <input type="text" className="form-control mt-3 mb-3 bg-secondary" placeholder="Full name" required autofocus="" />
                            <input type="email" className="form-control mb-3 bg-secondary" placeholder="Email address" required autofocus="" />
                            <input type="password" className="form-control mb-3 bg-secondary" placeholder="Password" required autofocus="" />
                            <input type="password" className="form-control mb-3 bg-secondary" placeholder="Repeat Password" required autofocus="" />
                            <button className="btn btn-dark mt-5 btn-block text-primary" type="submit"><i className="fas fa-user-plus"></i> Sign Up</button>
                            <a href="/" id="cancel_signup"><i className="fas fa-angle-left"></i> Back</a>
                        </form>
                    </div >
                </div>
            </div>
        </>
    )
}
export default SignUp
